<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="scarInfo">
          <div class="article">
            <label>수술명</label>
            <p>{{userScarInfoData.surgeryName}}</p>
          </div>
          <div class="article">
            <label>수술일정</label>
            <p>{{userScarInfoData.surgeryDate | moment('YYYY-MM-DD')}}</p>
          </div>
        </div>
        <div class="scarListWrap">
          <div class="monthlyItem" v-for="n in Object.keys(this.timeTableFlag).length" :key="n">
            <div class="status">
            <p class="board">{{n}}개월 후</p>
            <p class="add" @click="uploadImage(n)">이미지 등록</p>
            </div>
              <v-gallery class="image-box" :control-title = true :images = timeTableFlag[n][0].imgSet>
                <div class="imageSet" v-if = "(isDataFetched && scarList[n])">
                    <div class="viewWrap"  v-for="(itemSet , i) in scarList[n]" :key="i" :style="{ height: heightAuto + 'px'}">
                      <a
                        v-if="itemSet.url && itemSet.thumbnail"
                        href="javascript:void(0);"
                        :data-image="itemSet.url"
                        :data-title="itemSet.photoDate | moment('YYYY-MM-DD')"
                        :caption = true
                        :key="itemSet.id">
                        <div class="bgbox">
                          <img :src="itemSet.thumbnail">
                        </div>
                        <!-- <div class="img-title" v-html="itemSet.title"></div> -->
                      </a>
                      <div class="deleteAction" v-on:click.stop.prevent="deletePre(n, itemSet.id)">
                        <img src="@/assets/images/x_mimum.svg">
                      </div>
                     <!--<h6 class="dateTitle" v-text="itemSet.photoDate"></h6>-->
                    </div>
                </div>
              </v-gallery>
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet" @causeAction="deletePicture()"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '흉터관리 리스트',
        prevUrl: '/'
      },
      getCode: '',
      transNum: '',
      transId: '',
      scarList: [],
      scarDetailList: {},
      isDataFetched: false,
      userScarInfoData: [],
      keySet: '',
      valueSet: '',
      heightAuto: '',
      sampleImg: '',
      timeTableFlag: {
        1: [
          {
            month: false,
            IsAddMonth: false,
            imgSet: []
          }
        ],
        2: [
          {
            month: false,
            IsAddMonth: false,
            imgSet: []
          }
        ],
        3: [
          {
            month: false,
            IsAddMonth: false,
            imgSet: []
          }
        ],
        4: [
          {
            month: false,
            IsAddMonth: false,
            imgSet: []
          }
        ],
        5: [
          {
            month: false,
            IsAddMonth: false,
            imgSet: []
          }
        ],
        6: [
          {
            month: false,
            IsAddMonth: false,
            imgSet: []
          }
        ],
        7: [
          {
            month: false,
            IsAddMonth: false,
            imgSet: []
          }
        ],
        8: [
          {
            month: false,
            IsAddMonth: false,
            imgSet: []
          }
        ],
        9: [
          {
            month: false,
            IsAddMonth: false,
            imgSet: []
          }
        ],
        10: [
          {
            month: false,
            IsAddMonth: false,
            imgSet: []
          }
        ],
        11: [
          {
            month: false,
            IsAddMonth: false,
            imgSet: []
          }
        ],
        12: [
          {
            month: false,
            IsAddMonth: false,
            imgSet: []
          }
        ]
      },
      setCount: false
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.initData()
    this.visualTrans()
  },
  computed: {
    ...mapGetters([
      'GET_SCAR_INFOCODE',
      'GET_UPLOAD_LIST',
      'GET_FETCHED_SCARIMG',
      'GET_SCAR_INFO',
      'GET_SCARINFO_LIST'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_UPLOAD_PRE_DATA',
      'loading'
    ]),
    ...mapActions([
      'FETCH_SCAR_UPLOAD',
      'FETCH_SCAR_IMAGE',
      'DELETE_SCAR_IMAGE',
      'FETCH_SCARINFO'
    ]),
    callPrev () {
      if (this.setCount) {
        this.$router.push('/scar/scarList')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    async initData () {
      await this.fetchParam()
      await this.fetchImgList()
    },
    async drawThumbnail (id, firstNum, secondNum) {
      try {
        const requestThumbnailData = {
          id: id,
          thumbnail: true
        }
        await this.FETCH_SCAR_IMAGE(requestThumbnailData)
          .then(() => {
            const result = URL.createObjectURL(this.GET_FETCHED_SCARIMG)
            // 이미지의 주소에 모두 값을 주입해야함
            this.scarList[this.keySet[firstNum]][secondNum].thumbnail = result
            // document.getElementById('' + id + '').src = result
          })
      } catch (error) {
        console.log('error :', error);
        console.log('흉터관리 이미지 불러오기 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    async drawNormal (id, firstNum, secondNum) {
      try {
        const requestOriginData = {
          id,
          thumbnail: false
        }
        await this.FETCH_SCAR_IMAGE(requestOriginData)
          .then(() => {
            const result = URL.createObjectURL(this.GET_FETCHED_SCARIMG)
            // 이미지의 주소에 모두 값을 주입해야함
            this.scarList[this.keySet[firstNum]][secondNum].src = result
            this.scarList[this.keySet[firstNum]][secondNum].url = result
            this.scarList[this.keySet[firstNum]][secondNum].title = ''
            // document.getElementById('' + id + '').src = result
          })
      } catch (error) {
        console.log('error :', error);
        console.log('흉터관리 이미지 불러오기 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    async fetchParam () {
      const scarInfoArray = []
      this.getCode = Number(this.$route.params.code)
      console.log('가져온 파람', this.getCode)
      try {
        await this.FETCH_SCARINFO()
          .then(() => {
            console.log('GET_SCARINFO_LIST :', this.GET_SCARINFO_LIST)
            for (let i = 0; i < this.GET_SCARINFO_LIST.length; i++) {
              if (this.GET_SCARINFO_LIST[i].scarInfoCode === this.getCode) {
                scarInfoArray.push(this.GET_SCARINFO_LIST[i])
              }
            }
            if (scarInfoArray.length < 1) {
              this.loading(false)
              this.SET_POPUP(true)
              this.popupSet.count = 'another'
              this.popupSet.content = '유효하지 않은 주소입니다.'
              this.popupSet.closeType = 'action'
              this.popupSet.closeLink = '/scar/scarList'
              this.popupSet.nextLink = '/scar/scarList'
              return false
            }
            this.userScarInfoData = scarInfoArray[0]
          })
      } catch (error) {
        this.loading(false)
        console.log('error :', error);
        console.log('흉터관리 리스트 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    async drawPicture (id, firstNum, secondNum) {
      await this.drawThumbnail(id, firstNum, secondNum)
      await this.drawNormal(id, firstNum, secondNum)
    },
    deletePre (num, id) {
      this.transNum = num
      this.transId = id
      this.SET_POPUP(true)
      this.popupSet.content = '이미지를 삭제하시겠습니까?'
      this.popupSet.count = 'causeActionNormal'
    },
    async deletePicture () {
      let orderly
      const order = this.transNum
      console.log('활용할 데이터값', order)
      const id = this.transId
      for (let i = 0; i < this.scarList[order].length; i++) {
        if (this.scarList[order][i].id === id) {
          orderly = i
        }
      }
      console.log('가져온 로우의 순번', order)
      console.log('선택된 지울순번', orderly)
      console.log('가져온 이미지의 pk', id)
      // HTML 초기화
      const itemSet = document.querySelector('.monthlyItem').parentNode.childNodes[Number(order) - 1]
      const target = itemSet.querySelectorAll('.viewWrap')[orderly]
      const targetParent = target.parentNode

      console.log('지울타겟', target)
      targetParent.removeChild(target)
      const deleteSetLocation = this.scarList[order]
      try {
        const requestData = {
          scarInfoCode: this.getCode,
          scarCode: id
        }
        await this.DELETE_SCAR_IMAGE(requestData)
          .then(() => {
            delete deleteSetLocation[orderly]
            this.scarList = []
            this.transNum = ''
            this.transId = ''
            this.fetchImgList()
            this.SET_POPUP(false)
            this.SET_POPUP(true)
            this.popupSet.content = '이미지가 삭제되었습니다.'
            this.popupSet.count = 'single'
          })
      } catch (error) {
        console.log('error :', error);
        console.log('흉터관리 이미지 삭제 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    uploadImage (month) {
      const requestData = {
        scarInfoCode: Number(this.userScarInfoData.scarInfoCode),
        afterMonth: month
      }
      this.$store.commit('SET_UPLOAD_PRE_DATA', requestData)
      this.$router.push(`/scar/scarUpload/${this.userScarInfoData.scarInfoCode}`)
    },
    visualTrans () {
      const transHeight = ((window.innerWidth - 40) / 3)
      this.heightAuto = transHeight
    },
    async fetchImgList () {
      console.log('찾아주세요')
      this.loading(true)
      try {
        const requestData = {
          scarInfoCode: Number(this.userScarInfoData.scarInfoCode)
        }
        await this.FETCH_SCAR_UPLOAD(requestData)
          .then(() => this.makeUsual())
      } catch (error) {
        console.log('error :', error);
        console.log('흉터관리 이미지 업로드 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    moduleFetch () {
      // 지우기 신공
    },
    makeUsual () {
      this.scarList = this.GET_UPLOAD_LIST
      const excu = Object.entries(this.scarList)
      const keyArray = []
      const valueArray = []
      for (const [key, value] of excu) {
        keyArray.push(key)
        valueArray.push(value)
      }
      this.keySet = keyArray
      this.valueSet = valueArray
      console.log('객체를 배열로 변환한 값', keyArray)
      console.log('키값은?', Object.keys(this.scarList))
      const promiseList = []
      for (let i = 0; i < keyArray.length; i++) {
        // 몇월의 값에 이미지가 있는지 확인하기
        for (let j = 0; j < Object.keys(this.timeTableFlag).length; j++) {
          if (keyArray[i].indexOf(j) === 0) {
            this.timeTableFlag[j][0].month = true
          }
        }
        for (let j = 0; j < this.scarList[keyArray[i]].length; j++) {
          const imageId = this.scarList[keyArray[i]][j].id
          promiseList.push(this.drawPicture(imageId, i, j))
        }
      }
      Promise.all(promiseList).then(() => {
        for (let i = 0; i < keyArray.length; i++) {
          for (let j = 0; j < this.scarList[keyArray[i]].length; j++) {
            this.timeTableFlag[keyArray[i]][0].imgSet.push(valueArray[[i]][j].src)
          }
        }
        this.isDataFetched = true
        this.$nextTick(function () {
          this.loading(false)
        })
      })
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    this.setCount = false
  }
}
</script>
<style lang="scss" scoped>
.image-box{
  a {
    width : 100%;
    height: 100%;
    clear: both;
    display: inline-block;
    margin: 0 10px 10px 0;
    position: relative;
    text-align: center;
    .bgbox {
      width : 100%;
      height: 100%;
      vertical-align:middle;
      border-radius: 2px;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    &:hover {
      .img-title { color: #232323; }
    }
  }
  .v-gallery {
    width: 100%;

    & > div {
      display: block !important;
      width : 100% !important;
      height: 100% !important;
    }
  }
}
</style>
